import { render, staticRenderFns } from "./ConfirmResetPassword.vue?vue&type=template&id=a45aa04c&scoped=true&"
import script from "./ConfirmResetPassword.vue?vue&type=script&lang=js&"
export * from "./ConfirmResetPassword.vue?vue&type=script&lang=js&"
import style0 from "./ConfirmResetPassword.vue?vue&type=style&index=0&id=a45aa04c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a45aa04c",
  null
  
)

export default component.exports